export const getHtmlContentForLinkedEventMessage = (eventName, url) => `<p>"<b>${eventName}</b>" is open for purchase <br/>
    <a href="${url}" target="_blank" class="link-message-text cursor-pointer font-semibold">Click here to enter</a></p>`;
